// Filters exposed by the /clients route. Field names below are the plain model
// fields served by ContactFilterSet (conversations/api/filters/contact.py); the
// DRF lookup suffix is derived from the operator by FILTER_OPERATOR_MAP in
// src/services/queryHelpers.js, so it is never spelled out here.

export const LAST_ACTIVITY_WINDOWS = ['7d', '30d', '90d'];

const LAST_ACTIVITY_WINDOW_DAYS = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
};

export const EMPTY_FILTERS = {
  assignedToMe: false,
  hasActiveConversation: false,
  lastActivityWindow: null,
  city: '',
  state: '',
};

export const CLIENTS_FILTERS_STORAGE_KEY = 'beworks:clients:filters';

export const readStoredFilters = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) return EMPTY_FILTERS;
  try {
    const raw = window.sessionStorage.getItem(CLIENTS_FILTERS_STORAGE_KEY);
    if (!raw) return EMPTY_FILTERS;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return EMPTY_FILTERS;
    return { ...EMPTY_FILTERS, ...parsed };
  } catch {
    return EMPTY_FILTERS;
  }
};

export const writeStoredFilters = (filters) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(CLIENTS_FILTERS_STORAGE_KEY, JSON.stringify(filters));
  } catch {
  }
};

export const countActiveFilters = (f) => {
  if (!f) return 0;
  let n = 0;
  if (f.assignedToMe) n += 1;
  if (f.hasActiveConversation) n += 1;
  if (f.lastActivityWindow) n += 1;
  if (f.city?.trim() || f.state?.trim()) n += 1;
  return n;
};

const lastActivityCutoff = (window) => {
  const days = LAST_ACTIVITY_WINDOW_DAYS[window];
  if (!days) return null;
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - days);
  return cutoff.toISOString();
};

export const buildFilterModel = (f) => {
  const items = [];
  if (!f) return { items };

  if (f.assignedToMe) {
    items.push({ field: 'assigned_to_me', operator: '=', value: true });
  }
  if (f.hasActiveConversation) {
    items.push({ field: 'has_active_conversation', operator: '=', value: true });
  }

  const cutoff = lastActivityCutoff(f.lastActivityWindow);
  if (cutoff) {
    items.push({ field: 'last_message_at', operator: '>=', value: cutoff });
  }

  items.push({ field: 'city', operator: 'icontains', value: f.city?.trim() });
  items.push({ field: 'state', operator: 'icontains', value: f.state?.trim() });

  return { items };
};
